import { LanguagesEnum } from '@/api/enums';
import { SystemRoles } from '@/client/users';
import { DashboardType, LAST_SELECTED_DASHBOARD } from '@/common/constants';
import { LanguageContext } from '@/common/context/LanguageContext';
import { MobileUnsupportedScreen } from '@/components/dashboards/MobileUnsupportedScreen';
import { useAppDispatch, useAppSelector } from '@/hooks/store';
import { setCurrentDashboard } from '@/store/features/dashboard';
import { selectCurrentUser } from '@/store/features/users';
import { isMobile } from '@/utils/helpers/ui.helper';
import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Md5 } from 'ts-md5';
import userflow from 'userflow.js';

type AppDashboardTypeSetterProps = {
  isAdmin: boolean;
};

export const AppDashboardTypeSetter: React.FC<AppDashboardTypeSetterProps> = ({
  isAdmin,
}) => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectCurrentUser);
  const { changeLanguage } = useContext(LanguageContext);

  useEffect(() => {
    if (isAdmin) {
      localStorage.setItem(LAST_SELECTED_DASHBOARD, DashboardType.ADMIN);
      dispatch(setCurrentDashboard(DashboardType.ADMIN));

      if (
        process.env.REACT_APP_USERFLOW_TOKEN &&
        (currentUser?.account?.enableUserflow ||
          currentUser?.account?.freeTrialEndsAt)
      ) {
        userflow.init(process.env.REACT_APP_USERFLOW_TOKEN);
        userflow.identify(Md5.hashStr(currentUser.id), {
          locale_code:
            currentUser.language === LanguagesEnum.DK ? 'da-DK' : 'en-US',
        });
      }
    } else {
      localStorage.setItem(LAST_SELECTED_DASHBOARD, DashboardType.LEARNER);
      dispatch(setCurrentDashboard(DashboardType.LEARNER));

      userflow.reset();
    }

    changeLanguage(currentUser?.language);
  }, [isAdmin]);

  if (
    isAdmin &&
    isMobile() &&
    currentUser?.role?.code !== SystemRoles.DEVELOPER
  ) {
    return <MobileUnsupportedScreen />;
  }

  return <Outlet />;
};
